<div class="main">
  <router-outlet/>
</div>